const state = {
  pageAttributesInPageOptions: 0,
  matrixComplete: false,
  showUpload: false,
  personalizationFullPage: true,
  addToCartFullPage: false,
  disableDeleteUploadAfterConnect: false
};

const getters = {
  getDisableDeleteUploadAfterConnect: state => {
    return state.disableDeleteUploadAfterConnect;
  },
  getPageAttributesInPageOptions: state => {
    return state.pageAttributesInPageOptions;
  },
  getMatrixComplete: state => {
    return state.matrixComplete;
  },
  getShowUpload: state => {
    return state.showUpload;
  },
  getPersonalizationFullPage: state => {
    return state.personalizationFullPage;
  },
  getAddToCartFullPage: state => {
    return state.addToCartFullPage;
  }
};

const mutations = {
  setMatrixComplete: (state, payload) => {
    state.matrixComplete = payload;
  },
  setShowUpload: (state, payload) => {
    state.showUpload = payload;
  },
  setPersonalizationFullPage: (state, payload) => {
    state.personalizationFullPage = payload;
  },
  setAddToCartFullPage: (state, payload) => {
    state.addToCartFullPage = payload;
  },
  setDisableDeleteUploadAfterConnect: (state, payload) => {
    state.disableDeleteUploadAfterConnect = payload;
  }
};

const actions = {
  setMatrixComplete: ({ commit }, payload) => {
    commit("setMatrixComplete", payload);
    commit("setShowUpload", payload);
  },
  setShowUpload: ({ commit }, payload) => {
    commit("setShowUpload", payload);
  },
  setPersonalizationFullPage: ({ commit }, payload) => {
    commit("setPersonalizationFullPage", payload);
  },
  setAddToCartFullPage: ({ commit }, payload) => {
    commit("setAddToCartFullPage", payload);
  },
  setDisableDeleteUploadAfterConnect: ({ commit }, payload) => {
    commit("setDisableDeleteUploadAfterConnect", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
